export default {
  /** @name 是否显示弹窗 */
  value: { type: Boolean, default: true },
  /** @name 弹窗宽度或Input组件的输入框宽度 */
  width: { type: [String, Number], default: '100%' },
  /** @name 左侧位置偏移量 */
  offset: { type: Number, default: 200 },
  /** @name 标题 */
  title: { type: String, default: '开始扫码' },
  /** @name 是否将弹层放置于body内 */
  transfer: { type: Boolean, default: true },
  /** @name 搜索输入框的的placeholder */
  searchPlaceholder: { type: String, default: '搜索商品' },
  /** @name 获取当前表格的列定义 */
  tableColumnDefUrl: {
    type: String,
    default: 'rest/main/dict/getTableByCode?tableCode=SCAN_GOODS_TABLE_PLAN',
  },
  /** @name 获取表格数据的接口地址 */
  tableDataUrl: { type: String, default: '' },
  /** @name 获取表格数据的参数 */
  requestTableDataParameters: { type: Object },
  /** @name 表格拆行的依据 */
  treeRes: { type: String, default: 'data.parent' },
  /** @name 是否启用单条模式 */
  isSingle: { type: Boolean, default: false },
  /** @name 是否隐藏任务数计算，隐藏后不显示扫码组件左上角任务数统计和上表只显示当前扫码的信息 */
  hiddenTaskNumber: { type: Boolean, default: false },
  /** @name 是否禁用删除功能（不可见） */
  disableDeleted: { type: Boolean, default: false },
  /** @name 是否禁用编辑功能（不可见） */
  disableEdit: { type: Boolean, default: false },
  /** @name 库存选择器Props */
  selectStockProps: {
    type: Object,
    default() {
      return {}
    },
  },
}
